import React from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import Heading from '@cotyorg/ccx-atoms/Heading';
import { CardoCarousel } from '@cotyorg/ccx-organism-carousel';
import Paragraph from '@cotyorg/ccx-atoms/Paragraph';
import BBCodeParser from '@cotyorg/ccx-utils/js/components/BBCodeParser';
import SectionHeader from '../../../../atoms/SectionHeader';

export const Carousel = ({ sectionHeadings, description }) => (
  <div className="carousel-section">
    <div className="grid-container">
      <div className="grid-x grid-margin-x">
        <div className="cell">
          <SectionHeader>
            <Heading extraClass="section__title" level={2}>
              {R.path(['carousel', 'heading'])(sectionHeadings)}
            </Heading>
            {description && (
              <div className="match-finder-description">
                {R.compose(
                  R.addIndex(R.map)((paragraph, index) => (
                    <p>
                      <BBCodeParser>{paragraph}</BBCodeParser>
                    </p>
                  )),
                  R.filter((paragraph) => !!paragraph),
                  R.split(/\n/)
                )(description)}
              </div>
            )}
          </SectionHeader>

          <CardoCarousel
            cardoProps={{
              cardoStoreDataKey: 'sectionCarousel',
              isTitleUnderlined: false,
              contentTheme: 'transparent',
              headingLevel: 5,
              decorativeImages: true,
            }}
            cardsPerPageMap={{
              xsmall: 1,
              small: 2,
              medium: 5,
              large: 5,
              xlarge: 5,
            }}
            carouselProps={{
              rightChevronIconSrc: '/ccx-files/assets/arrow-right.svg',
              leftChevronIconSrc: '/ccx-files/assets/arrow-left.svg',
              carouselsStoreDataKey: 'sectionCarousel',
            }}
          />
        </div>
      </div>
    </div>
  </div>
);

Carousel.propTypes = {
  sectionHeadings: PropTypes.instanceOf(PropTypes.object),
  description: PropTypes.string,
};
